module.exports = __webpack_public_path__ + "img/outdoormidia.8f9d143c.png";